<template>
  <div
    class="items mt-40"
  >
    <el-row
      type="flex"
      justify="space-between"
      class="item pt-20 pb-20"
    >
      <span class="item-property">
        Status
      </span>
      <span
        v-if="reConciliationResponse.status === 'Success'"
        class="item-value"
      >
        {{ $t('pay.success_transaction') }}
      </span>
      <span
        v-else
        class="item-value"
      >
        {{ $t('pay.error_transaction') }}
      </span>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'ThankYou',
  data: function () {
    return {
      reConciliationResponse: this.$store.getters.reConciliationResponse
    };
  },
  created () {
    if (!Object.keys(this.reConciliationResponse).length) {
      this.$router.push({ name: 'SelectTeam' });
    }
  }
};
</script>

<style lang="scss" scoped>
.items {
  .item {
    border-bottom: 1px solid #e5e5e5;

    &-property {
      font-family: "Raleway Regular", serif;
      font-size: 16px;
      margin-right: 10px;
    }

    &-value {
      font-family: "Raleway Bold", serif;
      font-size: 16px;
    }
  }
}
</style>
